import VuexPersistence from 'vuex-persist';
import { RootState } from './store';

export const vuexPersist = new VuexPersistence<RootState>({
    storage: window.localStorage,
    modules: [ 'argoGrid' ],
});
